import { render, staticRenderFns } from "./ComplianceList.vue?vue&type=template&id=1cd2f3e4&scoped=true&"
import script from "./ComplianceList.vue?vue&type=script&lang=js&"
export * from "./ComplianceList.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceList.vue?vue&type=style&index=0&id=1cd2f3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd2f3e4",
  null
  
)

export default component.exports